// DS — arkusz dolny. Od reguły 49 (R6) NIE MA własnej anatomii: `Dialog` jest
// arkuszem na telefonie i oknem na 1440, ten sam nagłówek 56 px z X 44 × 44, ta sama
// przewijana treść, ta sama stopka. Ten plik zostaje CIENKIM ALIASEM na czas przejścia
// — daje tytuł, pole wyszukiwania i przypis, i nic poza tym. Nowy kod woła `Dialog`
// z `title` (i `footer`, jeśli arkusz ma akcję).
//
// Otwiera go kafel „Wszystkie (N)” przy > 6 pozycjach; wybór zamyka arkusz sam.

import type { ReactNode } from 'react'

import { Dialog } from './Dialog'

export interface BottomSheetProps {
  title: string
  onClose: () => void
  /** Pole wyszukiwania nad treścią; `placeholder` od wywołującego (i18n). */
  search?: { value: string; onChange: (v: string) => void; placeholder: string; label?: string }
  /** Zdanie pod siatką („Przewiń, żeby zobaczyć pozostałe 7”). */
  note?: ReactNode
  children: ReactNode
}

export function BottomSheet({ title, onClose, search, note, children }: BottomSheetProps) {
  return (
    <Dialog title={title} onClose={onClose}>
      {search ? (
        <div className="field ds-sheet-search">
          <input
            type="search"
            value={search.value}
            placeholder={search.placeholder}
            aria-label={search.label ?? search.placeholder}
            onChange={(e) => search.onChange(e.target.value)}
            data-autofocus
          />
        </div>
      ) : null}
      {/* Przewijanie zatrzymuje się na końcu listy: gest nie przechodzi na stronę pod
          arkuszem i nie odpala odświeżenia pociągnięciem. Robi to `.dg-body` Dialogu —
          ta klasa zostaje wyłącznie dla siatki kafli, która się w niej układa. */}
      <div className="ds-sheet-body">{children}</div>
      {note ? <div className="ds-sheet-note">{note}</div> : null}
    </Dialog>
  )
}

export default BottomSheet
